module.exports = __webpack_public_path__ + "img/PERCENT.5720aae4.svg";